export function isProdEnv(environment: string): boolean {
  return environment === 'production' || environment === 'production-eu' || environment === 'P2';
}
